/* eslint-disable react/no-unknown-property */
import {
  selectIsOnModeCreateCommentGoterest,
  selectSceneSelected,
} from '@containers/Home/selectors';
import { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HeaderWrapper } from './styled';
import dynamic from 'next/dynamic';
import { actions } from '@containers/Home/slice';
import formatDistance from 'date-fns/formatDistance';

const DialogSearchLocation = dynamic(() => import('./DialogSearchLocation'));

const Header = memo(() => {
  const dispatch = useDispatch();
  const sceneSelected = useSelector(selectSceneSelected);
  const isOnModeCreateCommentGoterest = useSelector(
    selectIsOnModeCreateCommentGoterest,
  );

  const [isShowDialogSearchLocation, setIsShowDialogSearchLocation] =
    useState(false);

  const onOpenDialogSearchLocation = () => setIsShowDialogSearchLocation(true);

  const onCloseDialogSearchLocation = useCallback(
    () => setIsShowDialogSearchLocation(false),
    [],
  );

  const onToggleModeCreateCommentScene = () =>
    dispatch(
      actions.onChangeIsOnModeCreateCommentGoterest(
        !isOnModeCreateCommentGoterest,
      ),
    );

  return (
    <HeaderWrapper id="themeHeader">
      <div className="cards-fly">
        <div className="cards-header">
          <div className="--title">
            <i className="fa-solid fa-panorama"></i>
            <span>{sceneSelected?.title}</span>
          </div>
        </div>
        <div className="cards-body">
          <div className="--avatar">
            <img
              src={
                sceneSelected?.contribute_avatar || '/static/img/logostf.jpg'
              }
              alt=""
            />
          </div>
          <div className="--txt">
            <div className="--name">
              @{sceneSelected?.contribute_name || 'Starfruitjsc'}
            </div>
            <div className="--viewtime">
              <div className="--view">{sceneSelected?.view_count} lượt xem</div>
              ·
              {(sceneSelected?.contribute_time ||
                sceneSelected?.created_at) && (
                <div className="--time">
                  {formatDistance(
                    new Date(
                      sceneSelected?.contribute_time ||
                        sceneSelected?.created_at,
                    ),
                    new Date(),
                    {
                      addSuffix: true,
                    },
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="search" onClick={onOpenDialogSearchLocation}>
        <input type="text" placeholder="Tìm kiếm địa điểm" readOnly />
        <div className="--icon-search">
          <i className="fa-light fa-magnifying-glass"></i>
        </div>
      </div>

      <div className="addInfo" onClick={onToggleModeCreateCommentScene}>
        <img src="/static/img/icon-2.svg" alt="" />
      </div>

      <DialogSearchLocation
        isVisible={isShowDialogSearchLocation}
        onCancel={onCloseDialogSearchLocation}
      />
    </HeaderWrapper>
  );
});

export default Header;
